export const dangerousMessage = 'Please do not use letters "<" and ">" in this field';
